module.exports = __webpack_public_path__ + "static/media/unnamed.3e235ca7.png";